import {
  BrowserRouter,
} from "react-router-dom";
import Header from "./Shared/Header";
import Footer from "./Shared/Footer";
import "./i18n";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import Routing from "./Routes/Routes";

function App() {
  return (
    <div>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter>
          <Header />
          <Routing />
          <Footer />
        </BrowserRouter>
      </I18nextProvider>
    </div>
  );
}

export default App;
